export default {
  title: 'API-Schlüssel erstellen',
  reveal_warning: 'Speichern Sie diesen Schlüssel jetzt — er wird nicht erneut angezeigt.',
  form: {
    name: 'Name',
    name_placeholder: 'z. B. Produktionsschlüssel',
  },
  buttons: {
    cancel: 'Abbrechen',
    create: 'Erstellen',
    done: 'Fertig',
  },
  toasts: {
    error: 'Der Schlüssel konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
  },
};
